import { render, staticRenderFns } from "./propertyActionStatisticSummary.vue?vue&type=template&id=50c28a56&"
import script from "./propertyActionStatisticSummary.vue?vue&type=script&lang=js&"
export * from "./propertyActionStatisticSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports